import { BaseRouteService } from 'core/services';

class OrderPIIRouteService extends BaseRouteService {
	constructor() {
		super();
		this.base = 'order-pii/';
	}

	checkIfOrderAddressPIIExistsAsync(id, isFulfillmentOrder, isView, orderId) {
		return super.update(this.base + 'check-if-pii-data-exists/{id}/{isFulfillmentOrder}/{isView}/{orderId}', null, {
			id,
			isFulfillmentOrder,
			isView,
			orderId,
		});
	}
}

export default OrderPIIRouteService;



// WEBPACK FOOTER //
// ./src/common/data/route-services/OrderPIIRouteService.js